import { useContext } from "react";
import PageTitle from "./../layouts/PageTitle";
import BooksAcquiredList from "../components/BooksAcquired";
import MyEbooks from "../components/MyEbooks";
import GlobalContext from "../contexts/global";
import { Tabs } from "antd";

export default function BooksAcquired() {
  const { TabPane } = Tabs;
  const { global } = useContext(GlobalContext);

  // Mesma flag que já controla o link "Essenciais" no menu principal
  // (Header.js) — configurações globais do backoffice, tela "Cadernos
  // Essenciais" ("Ativar aba"), headerOptions[type=HEALTH].actived.
  const essenciaisActived = !!global?.headerOptions?.find(
    (x) => x.type === "HEALTH"
  )?.actived;

  const tabItems = [
    {
      key: '1',
      label: 'Cadernos Jurídicos',
      children: <BooksAcquiredList />
    },
    ...(essenciaisActived
      ? [
          {
            key: '2',
            label: 'Cadernos Essenciais',
            children: <MyEbooks />
          }
        ]
      : [])
  ];

  return (
    <>
      <div className="page-content header-padding-main">
        <PageTitle parentPage="CJ" childPage="Meus Cadernos" />

        <div className="container box-main mt-5 mb-5">
          <Tabs
            defaultActiveKey="1"
            items={tabItems}
            size="large"
            style={{ minHeight: '400px' }}
          />
        </div>

      </div>
    </>
  );
}
